<script setup lang="ts">
import { Maintenance } from 'assets/data/icons';

const Icon = useIcon();

interface IBindings {
  'stroke-width': string;
  'fill-rule': string;
  'clip-rule': string;
  'stroke-linecap': string;
  'stroke-linejoin': string;
  viewBox: string;
  fill: string;
}

const bindings: IBindings = {
  'stroke-width': '2',
  'fill-rule': 'evenodd',
  'clip-rule': 'evenodd',
  'stroke-linecap': 'round',
  'stroke-linejoin': 'round',
  viewBox: '0 0 76 76',
  fill: 'white',
};
</script>
<template>
  <Icon :path="Maintenance" class="w-7" :bindings="bindings" stroked />
</template>
